import React, { createContext, useContext } from 'react';

import { OverviewStatsDataType } from './types';

type OverviewStatsContent = {
  overviewStats?: OverviewStatsDataType;
};

export const OverviewStatsContext = createContext<OverviewStatsContent>({
  overviewStats: {
    base_rent: {
      community: undefined,
      market: undefined,
    },
    price_per_square_foot: {
      community: undefined,
      market: undefined,
    },
    living_types: [],
    ratings: {
      community: undefined,
      market: undefined,
      community_count: 0,
    },
  },
});

export const useOverviewStatsContext = () => useContext(OverviewStatsContext);
